import React from 'react'
import { Link } from 'react-router-dom';

function Product ( {product,showBtn} )  {
  return (
    
        <div className="card" style={{width: "18rem"}}>
          <div className='img'>  <img src={product.image} className="card-img-top" alt={product.title}/></div>
            <div className="card-body">
                <h5 className="card-title">{product.title}</h5>
                {!showBtn&&<p className="card-text price">{product.price}</p>}
                 {showBtn && <Link to={`/products/${product.id}`} className="btn ">Details </Link>}
                 {/* {!showBtn && <p>{product.description}</p>} */}
            </div>
        </div>

  )
}

export default Product;